import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@repo/shadcn';
import { useFormContext } from 'react-hook-form';

import { ExpiryRestockItem } from './item.component';
import { TCreateExpiredStockAdjustment } from './schema';

// import { TCreatePrePurchaseForm } from './create-pre-purchase.schema';
// import { CreatePurchaseItem } from './item.component';

export const ExpiryRestockItemList = () => {
    // const { items } = useAppSelector((state) => state.expiryAdjustmentSlice);

    const { watch } = useFormContext<TCreateExpiredStockAdjustment>();

    const items = watch('items');

    const renderTableRows = () => {
        // items = 0;
        //
        // if (items) {
        // }

        if (!items || items.length === 0) {
            return (
                <TableRow>
                    <TableCell colSpan={7} className="py-4 text-center">
                        No items added.
                    </TableCell>
                </TableRow>
            );
        }

        // items ? items : []
        // items || []
        // items ?? []

        return items?.map((item, index) => (
            <ExpiryRestockItem
                item={item}
                serialNumber={index + 1}
                key={index}
            />
        ));
    };

    return (
        <Table>
            <TableHeader className={'rounded-md bg-white'}>
                <TableRow>
                    <TableHead className="w-[40px] px-2">SL.</TableHead>
                    <TableHead className={'text-left'}>Name</TableHead>
                    <TableHead>Expiry Date</TableHead>
                    <TableHead className="text-right">Quantity</TableHead>
                    <TableHead className="text-right">PP</TableHead>
                    <TableHead className="text-right">WP</TableHead>
                    <TableHead className="text-right">MRP</TableHead>
                    <TableHead className="text-right">Actions</TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>{renderTableRows()}</TableBody>
        </Table>
    );
};

ExpiryRestockItemList.displayName = 'CreatePurchaseItemList';
